<template>
    <div class="file-drop-area d-flex flex-column align-items-center justify-content-center p-3"
         :class="{ 'file-drop-area-over': dragOver, 'file-drop-area-disabled': disabled }"
         @dragover="onDragOver"
         @dragleave="onDragLeave"
         @drop="onDrop"
         @click="onClick">
        <i class="fa fa-cloud-upload fa-2x mb-2 text-muted"></i>
        <div class="file-drop-area-text text-center">{{ displayText }}</div>
        <input ref="fileInput"
               type="file"
               class="file-input"
               :accept="accept"
               :multiple="multiple"
               :disabled="disabled"
               @change="onChange">
    </div>
</template>

<script>
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

export default {
    name: 'FileDropAreaComponent',
    props: {
        value: {
            type: [File, Array],
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        accept: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: null
        },
        invalidFileMessage: {
            type: String,
            default: 'Selecione um arquivo válido.'
        }
    },
    data() {
        return {
            dragOver: false
        };
    },
    computed: {
        hasValue() {
            return this.multiple ? Array.isArray(this.value) && this.value.length > 0 : !!this.value;
        },
        displayText() {
            if (this.hasValue) {
                return this.multiple ? this.value.map(f => f.name).join(', ') : this.value.name;
            }
            return this.placeholder || (this.multiple
                ? 'Arraste os arquivos aqui ou clique para selecionar'
                : 'Arraste um arquivo aqui ou clique para selecionar');
        }
    },
    methods: {
        isFileValid(file) {
            if (!this.accept) {
                return true;
            }
            const name = (file.name || '').toLowerCase();
            const type = (file.type || '').toLowerCase();
            return this.accept.split(',').map(a => a.trim().toLowerCase()).filter(Boolean).some(a => {
                if (a.startsWith('.')) {
                    return name.endsWith(a);
                }
                if (a.endsWith('/*')) {
                    return type.startsWith(a.slice(0, -1));
                }
                return type === a;
            });
        },
        handleFiles(fileList) {
            if (this.disabled || !fileList || fileList.length === 0) {
                return;
            }
            const files = Array.from(fileList).filter(f => this.isFileValid(f));
            if (files.length === 0) {
                toast({
                    type: VueNotifications.types.error,
                    title: 'Upload de Arquivo',
                    message: this.invalidFileMessage,
                    timeout: 3000
                });
                return;
            }
            const result = this.multiple ? files : files[0];
            this.$emit('input', result);
            this.$emit('change', result);
        },
        onChange(event) {
            this.handleFiles(event.target.files);
            event.target.value = null;
        },
        onDragOver(event) {
            event.preventDefault();
            if (!this.disabled) {
                this.dragOver = true;
            }
        },
        onDragLeave(event) {
            event.preventDefault();
            this.dragOver = false;
        },
        onDrop(event) {
            event.preventDefault();
            this.dragOver = false;
            this.handleFiles(event.dataTransfer.files);
        },
        onClick() {
            if (!this.disabled) {
                this.$refs.fileInput.click();
            }
        }
    }
}
</script>

<style scoped lang="scss">
.file-drop-area {
    border: 2px dashed rgba(0, 0, 0, 0.25);
    border-radius: 0.25rem;
    cursor: pointer;
    transition: border-color 0.2s ease-out, background-color 0.2s ease-out;

    .file-drop-area-text {
        word-break: break-word;
    }

    input.file-input {
        position: absolute;
        height: 0;
        width: 0;
        opacity: 0;
    }

    &.file-drop-area-over {
        border-color: #20a8d8;
        background-color: rgba(32, 168, 216, 0.08);
    }

    &.file-drop-area-disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
}
</style>
